// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthorBannerSection_container__04lqJ"};